import { getCookie } from '../commons/cookie';
import getIsMobile from '../commons/utils/get-is-mobile';
import CONFIG from '../generated/config';

export const getPerimeterX = () => {
  // funcao obtida do time de metricas
  try {
    if (
      typeof window.top.dl_perimeterx === 'object' &&
      typeof window.top.dl_perimeterx.type_action === 'string'
    ) {
      return window.top.dl_perimeterx.type_action;
    }
  } catch (e) {
    return;
  }
};

export const getEparList = epar => {
  // funcao obtida do time de metricas
  try {
    let eparArr = [];
    let eparExists = false;
    let eparIsDefault = false;
    let sectionsCount = 1;
    let sections = 4;
    let separatorPrev,
      separatorCurrent = null;

    if (epar && epar.length > 0) {
      eparExists = true;
      for (let i = 0; i < epar.length; i++) {
        if (epar.substring(i, i + 1) === '_') {
          if (!(sectionsCount > sections)) {
            separatorCurrent = i;
            /* eslint-disable no-useless-escape */
            eparArr.push(epar.substring(separatorPrev, separatorCurrent).replace(/\_/g, ''));
            /* eslint-enable no-useless-escape */
            sectionsCount++;
          }
        }
        separatorPrev = separatorCurrent;
      }
      if (eparArr.length >= sections) {
        eparIsDefault = true;
      } else {
        eparIsDefault = false;
      }
      eparArr.push(epar.substring(separatorCurrent + 1, epar.length));
    }

    if ((eparExists === true && eparIsDefault === false) || eparExists === false) {
      return {};
    } else {
      return {
        midia: eparArr[0],
        formato: eparArr[1],
        subFormato: eparArr[2],
        parceiro: eparArr[3],
        campanha: eparArr[4]
      };
    }
  } catch (e) {
    return {};
  }
};

export const getPageLoadEventPayload = type => {
  switch (type) {
    case 'login':
      return getLoginPageLoadEventPayload();

    case 'signUpPF':
    case 'signUpPJ':
    case 'signUpGuest':
    case 'telemarketer':
    case 'completeCadastro':
      return getRegisterPageLoadEventPayload(type);

    default:
      return {};
  }
};

export const getLoginPageLoadEventPayload = () => {
  const eparId = getCookie('b2wEPar');
  const epar = getEparList(eparId ? eparId : '');
  const isMobile = getIsMobile();
  const url = window.top.location.href;
  const isCheckoutFLow = url.indexOf('sacola.') >= 0;

  return {
    event: 'pageview_login',
    page: window.top.location.pathname,
    title: window.top.document.title,
    url: url,
    AppID: isMobile ? 'MOBILESITE' : 'NAOMOBILE',
    epar: getCookie('b2wEPar'),
    midia: epar.midia,
    formato: epar.formato,
    subformato: epar.subFormato,
    parceiro: epar.parceiro,
    campanha: epar.campanha,
    gclid: getCookie('gclid'),
    chave: getCookie('b2wChave'),
    pagetype: 'Cliente',
    ambient: CONFIG.env === 'staging' ? 'hmlg-DESKTOP' : undefined,
    isMobile: isMobile,
    marca: CONFIG.brand,
    opn: getCookie('b2wOpn'),
    franq: getCookie('b2wFranq'),
    b2wRegion: getCookie('b2wRegion'),
    'versão-site': 'Responsivo',
    afpid: getCookie('afpid'),
    'b2w-uid': getCookie('b2wUid'),
    'b2w-pid': getCookie('b2wPid'),
    'b2w-sid': getCookie('b2wSid'),
    b2wChannel: getCookie('b2wChannel'),
    PerimeterX: getPerimeterX(),
    pagename: CONFIG.brand.toUpperCase() + ':Cliente:Login',
    cfinance: getCookie('cfinance'),
    form: isCheckoutFLow ? 'Form: Login - Checkout' : 'Form: Login - MinhaConta'
  };
};

export const getRegisterPageLoadEventPayload = type => {
  const eparId = getCookie('b2wEPar');
  const epar = getEparList(eparId ? eparId : '');
  const isMobile = getIsMobile();
  const url = window.top.location.href;
  const isCheckoutFLow = url.indexOf('sacola.') >= 0;
  const registerType = type === 'signUpPF' ? 'PF' : 'PJ';

  return {
    event: 'pageview_cadastro',
    page: window.top.location.pathname,
    title: window.top.document.title,
    url: url,
    AppID: isMobile ? 'MOBILESITE' : 'NAOMOBILE',
    epar: getCookie('b2wEPar'),
    midia: epar.midia,
    formato: epar.formato,
    subformato: epar.subFormato,
    parceiro: epar.parceiro,
    campanha: epar.campanha,
    gclid: getCookie('gclid'),
    chave: getCookie('b2wChave'),
    pagetype: 'Cliente',
    ambient: CONFIG.env === 'staging' ? 'hmlg-DESKTOP' : undefined,
    isMobile: isMobile,
    marca: CONFIG.brand,
    opn: getCookie('b2wOpn'),
    franq: getCookie('b2wFranq'),
    b2wRegion: getCookie('b2wRegion'),
    'versão-site': 'Responsivo',
    afpid: getCookie('afpid'),
    'b2w-uid': getCookie('b2wUid'),
    'b2w-pid': getCookie('b2wPid'),
    'b2w-sid': getCookie('b2wSid'),
    b2wChannel: getCookie('b2wChannel'),
    PerimeterX: getPerimeterX(),
    pagename: CONFIG.brand.toUpperCase() + ':Cliente:Cadastro:MinhaConta:' + registerType,
    cfinance: getCookie('cfinance'),
    form: isCheckoutFLow
      ? 'Form: Cadastro - Checkout - ' + registerType
      : 'Form: Cadastro - Painel - ' + registerType
  };
};

const getRegion = () => {
  const mesoRegion = getCookie('mesoRegion');
  const macroRegion = getCookie('macroRegion');
  const legionRegion = getCookie('legionRegion');

  if (!mesoRegion || !macroRegion || !legionRegion) {
    return undefined;
  }

  return `${mesoRegion}, ${macroRegion}, ${legionRegion}`;
};

export const getEventPayload = eventsProps => {
  const isMobile = getIsMobile();
  const eparId = getCookie('b2wEPar');
  const epar = getEparList(eparId ? eparId : '');
  const searchParams = new URLSearchParams(window.location.search);
  const gclidParam = searchParams.get('gclid');
  const gclid = gclidParam ? gclidParam : undefined;

  return {
    ...eventsProps,
    AppID: isMobile ? 'MOBILESITE' : 'NAOMOBILE',
    'b2w-pid': getCookie('b2wPid'),
    'b2w-sid': getCookie('b2wSid'),
    'b2w-uid': getCookie('b2wUid'),
    b2wChannel: getCookie('b2wChannel'),
    b2wRegion: getCookie('b2wRegion'),
    campanha: epar.campanha,
    cep: getCookie('persistentCep'),
    cfinance: getCookie('cfinance'),
    chave: getCookie('b2wChave'),
    customerId: getCookie('customerId'),
    epar: getCookie('b2wEPar'),
    formato: epar.formato,
    franq: getCookie('b2wFranq'),
    gclid,
    'gtm.start': new Date().getMilliseconds(),
    marca: CONFIG.brand,
    midia: epar.midia,
    opn: getCookie('b2wOpn'),
    page: window.top.location.pathname,
    pagename: CONFIG.brand.toUpperCase() + ':Cliente:Login',
    pagetype: 'Login',
    parceiro: epar.parceiro,
    referrer: window.top.document.referrer,
    region: getRegion(),
    subformato: epar.subFormato,
    testsAB: undefined,
    title: window.top.document.title,
    url: window.top.location.href,
    'versao-site': isMobile ? 'Responsivo' : 'Desktop'
  };
};

export const getLoginSuccessfulEventPayload = type => {
  const isFacebookLogin = type === 'FACEBOOK';

  const eventPayload = getEventPayload({
    event: 'event_login',
    eventCategory: 'login',
    eventAction: 'sucesso-login',
    eventLabel: isFacebookLogin ? 'facebook' : 'conventional'
  });

  return eventPayload;
};

export const getLoginErrorEventPayload = type => {
  const isFacebookLogin = type === 'FACEBOOK';

  const eventPayload = getEventPayload({
    event: 'event_login',
    eventCategory: 'login',
    eventAction: 'error',
    eventLabel: isFacebookLogin ? 'facebook' : 'conventional'
  });

  return eventPayload;
};
